// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c81c4895","498":"984ee60a"}[chunkId] + ".chunk.js";
};